import { useState } from 'react';
import { Icon } from '../icons/Icon';
import { Button, IconButton } from '../ui/controls';
import { useClient } from './context';

const DISMISSED = 'sd-notify-hint-dismissed';

function dismissedBefore(): boolean {
  try {
    return globalThis.localStorage?.getItem(DISMISSED) === '1';
  } catch {
    return false;
  }
}

/**
 * Web only (`ListHints` decides when): until the person decides, a hint above the conversations to turn on
 * notifications, which then also arrive with the messenger closed (web push). An iPhone in a browser tab gets
 * the home screen hint instead, the only place Safari allows them.
 * Asking needs a click (browsers ignore or punish an unprompted request); closing the hint keeps it closed.
 */
export function NotifyHint() {
  const client = useClient();
  const [permission, setPermission] = useState(() => (typeof Notification === 'undefined' ? 'unsupported' : Notification.permission));
  const [dismissed, setDismissed] = useState(dismissedBefore);
  if (dismissed || permission !== 'default') return null;
  const dismiss = () => {
    try {
      globalThis.localStorage?.setItem(DISMISSED, '1');
    } catch {
      // Private mode: the hint stays closed for this page only.
    }
    setDismissed(true);
  };
  return (
    <div className="notice notify-hint" role="status">
      <Icon name="bell" size="sm" />
      <span>새 메시지 알림을 받으려면 알림을 켜 주세요.</span>
      <Button
        size="sm"
        variant="primary"
        onClick={() =>
          void Notification.requestPermission().then((answer) => {
            setPermission(answer);
            if (answer === 'granted') void client.enablePush();
          }, () => {})
        }
      >
        알림 켜기
      </Button>
      <IconButton icon="x" iconSize="sm" label="알림 안내 닫기" onClick={dismiss} />
    </div>
  );
}
